import type { ReactElement } from 'react';
import type { SupabaseClient } from '@supabase/supabase-js';
import type { Guard } from '../App';
import { StepUpMethodSetting } from './StepUpMethodSetting';

/**
 * Subscriber-visible session line. The account email and service address are
 * accepted so this surface can keep them for the signed-in session, and they
 * are never written into the label.
 */
export function profileSessionLabel(accountEmail: string | null, serviceAddress: string): string {
  void accountEmail;
  void serviceAddress;
  return 'Signed in';
}

export function ProfileSecuritySettings(props: {
  readonly client: SupabaseClient;
  readonly guard: Guard;
  readonly ownerVerified: boolean;
  readonly onSignOut: () => void;
  readonly onChangePassword: () => void;
  readonly onRefresh: () => void;
  /** Signed-in account identity. Kept for the session; not rendered. */
  readonly accountEmail: string | null;
  /** Deployment service address. Kept for the connection; not rendered. */
  readonly serviceAddress: string;
}): ReactElement {
  return (
    <>
      <div className="profile-settings-grid">
        <div><small className="muted">Session</small><strong>{profileSessionLabel(props.accountEmail, props.serviceAddress)}</strong></div>
        <div><small className="muted">Owner verification</small><strong>{props.ownerVerified ? 'Verified for this session' : 'Verification available when required'}</strong></div>
      </div>
      <StepUpMethodSetting client={props.client} guard={props.guard} />
      <p className="muted">Protected actions are confirmed with your authenticator code or, if you chose it, your password. On the iPad, Lock Brunel keeps the signed-in session and unlocks locally with a personal PIN, Face ID, or the device passcode.</p>
      <div className="row">
        <button type="button" onClick={props.onChangePassword}>Change password</button>
        <button type="button" onClick={props.onSignOut}>Sign out</button>
        <button type="button" className="link" onClick={props.onRefresh}>Refresh data</button>
      </div>
      <small className="muted">Sign out ends the saved session. Brunel refreshes the desk automatically; use Refresh data only when troubleshooting or when you want an immediate reread.</small>
    </>
  );
}
